// fetchRandomUsernames.js
'use strict';
import fetch from '../resource/customFetch.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';
import {
  SET_OPERATION_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

const selectPath = ['register', 'randomUsernames'];

/**
 * Fetch random username
 * @kind action
 * @return {Promise} Action promise.
 */
const fetchRandomUsernames = () => async dispatch => {
  const fetchOptions = {
    method: 'GET',
    headers: {
      ...getHeaders(),
    },
  };

  const url = getResourceUrl({ endpoint: '/user/usernames.json' });

  dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
  try {
    const response = await fetch(url.href, fetchOptions);

    if (!response.ok) {
      await handleFetchError({ response });
    }

    const randomUsernames = (await response.json()) || [];
    dispatch({
      type: SET_OPERATION_DATA,
      payload: { selectPath, data: randomUsernames },
    });

    return dispatch({ type: SET_NETWORKING_SUCCESS, payload: { selectPath } });
  } catch (error) {
    return dispatch({
      type: SET_NETWORKING_ERROR,
      payload: { selectPath, error },
    });
  }
};

export default fetchRandomUsernames;
